/**
 * Single source of truth for the workspace's navigation vocabulary.
 *
 * `getActions` emits short link tokens ("posts", "home/setup", ...). The old
 * tab shell resolved them with relative navigation, which broke depending on
 * the current route depth. Everything is absolute now.
 */

export const HOME_PANEL_IDS = [
  "pipeline",
  "competition",
  "tasks",
  "calendar",
  "reviews",
  "notes",
  "obligations",
] as const;

export type HomePanelId = (typeof HOME_PANEL_IDS)[number];

const PANEL_ANCHOR_LINKS: Record<string, HomePanelId> = {
  "home/obligations": "obligations",
  "home/calendar": "calendar",
  "home/reviews": "reviews",
  "home/notes": "notes",
  "home/tasks": "tasks",
  calendar: "calendar",
};

export function resolveActionLink(
  link: string | undefined,
  clientId: string
): string | null {
  if (!link) return null;
  if (link === "home/setup") return `/app/${clientId}/settings`;
  const panel = PANEL_ANCHOR_LINKS[link];
  if (panel) return `/app/${clientId}/home#${panel}`;
  return `/app/${clientId}/${link}`;
}

export function homeTabRedirect(tab: string, clientId: string): string {
  if (tab === "setup") return `/app/${clientId}/settings`;
  const panel = PANEL_ANCHOR_LINKS[`home/${tab}`];
  if (panel) return `/app/${clientId}/home#${panel}`;
  return `/app/${clientId}/home`;
}
